import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'environments/environment';

@Component({
  selector: 'redirect-dialog',
  templateUrl: './redirect-dialog.component.html',
  styleUrls: ['./redirect-dialog.component.scss']
})
export class RedirectDialogComponent implements OnInit {
  public externalSupportUrl = environment.externalSupportUrl;
  public mobileUrl = environment.mobileUrl;
  redirectTime = 10000; // 10 seconds to redirect to mobile

  constructor(private dialog: MatDialogRef<RedirectDialogComponent>) { }

  ngOnInit(): void {
    this.redirectToMobile();
  }

  close(): void {
    this.dialog.close(true);
  }

  redirectToMobile(): void {
    setTimeout(() => {
      window.location.href = this.mobileUrl;
    }, this.redirectTime);
  }

}
